module.exports = __webpack_public_path__ + "img/单选框_选中.49fef35a.svg";